export default "__VITE_ASSET__DkzrjG2v__"